// extracted by mini-css-extract-plugin
export default {"header":"header---e9gu8","label":"label---PG_tU","resizeHandle":"resizeHandle---osmFs"};